<template>
  <div class="equipInfo">
    <div v-for="(info, index) in equipInfo" :key="index" class="info-list">
      <div class="info-name">
        <div class="label-icon"></div>
        <div>{{ info.name }}</div>
      </div>
      <div class="info-value">
        {{ info.value }}
        {{ info.unit }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["equip_data"],
  data() {
    return {
      timer: null,
      num: moment().diff(moment("2023-10-19 17:00:00"), "hours"),
    };
  },
  computed: {
    equipInfo() {
      let ind =
        (this.equip_data &&
          this.equip_data.attributes &&
          this.equip_data.attributes.attributes.find(
            (item) => item.name === "应用行业"
          )?.value) ||
        null;
      let use =
        (this.equip_data &&
          this.equip_data.attributes &&
          this.equip_data.attributes.attributes.find(
            (item) => item.name === "客户行业"
          )?.value) ||
        null;
      return [
        {
          name: this.$t("Name"),
          value: (this.equip_data && this.equip_data.name) || "",
          unit: "",
        },
        {
          name: this.$t("Type"),
          value:
            this.equip_data &&
            this.equip_data.attributes &&
            this.equip_data.attributes.attributes.filter((item) => {
              return item.name == "设备型号";
            })[0].value,
          unit: "",
        },
        {
          name: this.$t("Serial No."),
          value: (this.equip_data && this.equip_data.root_sn) || "",
          unit: "",
        },
        {
          name: this.$t("customer_name"),
          value: (this.equip_data && this.equip_data.customer_txt) || "",
          unit: "",
        },
        {
          name: this.$t("industry"),
          value:this.handleReturnFormat(use, ind),
          unit: "",
        },
        {
          name: this.$t("Running time"),
          // value:[" 8708 " + this.$t("Hours")," 7616 " + this.$t("Hours")," 6953 " + this.$t("Hours")] [this.$route.query.index-1]
          value:  this.equip_data.uptime || "0",//6480
          unit: this.$t("Hours"),
        },
      ];
    },
    totalDuration(){ //演示总时长
      return this.$store.state.equipManagement.totalDuration
    }
  },
  methods: {
    /* 格式化处理 应用行业 */ 
    handleReturnFormat(use,ind){
      if(use&&ind){
        return `${this.$t(`overview_dynamic.industy_dict["${use}"]`)}-${this.$t(`overview_dynamic.industy_dict["${ind}"]`)}`
      }else if(use&&!ind){
        return this.$t(`overview_dynamic.industy_dict["${use}"]`);
      }else if(!use&&ind){
        return this.$t(`overview_dynamic.industy_dict["${ind}"]`);
      }else{
        return '-';
      }
    }
  },
  components: {},
  mounted() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.num = moment().diff(moment("2023-10-19 17:00:00"), "hours");
    }, 3600000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipInfo {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .info-list {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-name {
      flex: 2;
      display: flex;
      align-items: center;
    }
    .label-icon {
      display: inline-block;
      margin-right: 10px;
      width: 3px;
      height: 10px;
      background: #74778c;
    }
    .info-value {
      flex: 3;
      font-size: 16px;
    }
  }
}
</style>
